<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Depot stock location was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit depot stock location</h1>
    <app-audit-line [data]='this.depotStockLocation'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-depot-stock-location-form [depotStockLocation]='this.depotStockLocation'></app-depot-stock-location-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/workshop/depot-stock-locations'>Cancel</button>
    </form>
  </div>
</div>
